<template>
    <div>
        <div v-if="media">
            <ion-avatar class="big-avatar" v-if="thumbnail">
                <img :src="thumbnail">
            </ion-avatar>
            <div v-else class="media-info">
                Your audio file is ready for upload
            </div>
            <ion-button shape="round" v-on:click="resetMedia">{{buttonAction}} Again</ion-button>
        </div>
        <div v-else>
            <div v-if="isAndroid || isIos">
                <ion-button shape="round" v-on:click="cordovaAudio()">{{buttonText}}</ion-button>
            </div>
            <div v-else-if="isIos" class="media-recorder">
                <!-- @test - isAndroid may work on ios, this may not -->
                <!-- DOES NOT WORK -->
                <div class="record-button">
                    <input type="file" accept="audio/*" capture class="uploader" v-on:change="onUpload($event)">
                    {{buttonText}}
                </div>
            </div>
            <div v-else>
                <audio-recorder :set-media="setMedia" />
            </div>
        </div>
    </div>
</template>

<script>

import {device} from '@/mixins/device';
import AudioRecorder from '@/components/AudioRecorder.vue'

export default {
    name: 'audio',
    created : function () {
        this.type = 'audio';
    },
    props : {
        clearMedia : Function,
        setMedia : Function,
        media : {
            type : String|null,
            default : null
        },
        thumbnail : {
            type : String|null,
            default : null
        },
    },
    components: {
        AudioRecorder
    },
    mixins : [device],
    methods : {
        resetMedia : function () {
            this.clearMedia();
        },
        onUpload : function (event) {
            // console.log('audio file uploaded', event);
            this.setMedia(event.target.files[0]);
        },
        cordovaAudio : function () {
            // "The mime field is required."
            navigator.device.capture.captureAudio(this.cordovaUpload, this.cordovaError, { limit : 1 });
        }
    }
}
</script>